export default {
  AUD: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '$',
  },
  BGN: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'лв',
  },
  BRL: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'R$',
  },
  CAD: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '$',
  },
  CHF: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'CHF',
  },
  CNY: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '¥',
  },
  CZK: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'Kč',
  },
  DKK: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'kr',
  },
  EUR: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '€',
  },
  GBP: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '£',
  },
  HKD: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '$',
  },
  HRK: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'kn',
  },
  HUF: {
    separator: ',',
    decSeparator: '.', // no-fraction
    prefixed: false,
    symbol: 'Ft',
  },
  IDR: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'Rp',
  },
  ILS: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '₪',
  },
  INR: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '₹',
  },
  JPY: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '¥',
  },
  KRW: {
    separator: ',',
    decSeparator: '.', // no-fraction
    prefixed: false,
    symbol: '₩',
  },
  MXN: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '$',
  },
  MYR: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'RM',
  },
  NOK: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'kr',
  },
  NZD: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '$',
  },
  PHP: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '₱',
  },
  PLN: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'zł',
  },
  RON: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'lei',
  },
  RUB: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'руб',
  },
  SEK: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'kr',
  },
  SGD: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '$',
  },
  THB: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '฿',
  },
  TRY: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: '₺',
  },
  UAH: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: ' грн',
  },
  USD: {
    separator: ',',
    decSeparator: '.',
    prefixed: true,
    symbol: '$',
  },
  ZAR: {
    separator: ',',
    decSeparator: '.',
    prefixed: false,
    symbol: 'R',
  },
};
